import React, { forwardRef } from "react";
import { InputText } from "primereact/inputtext";

const GeneriInputId = forwardRef((props, ref) => {
  return <InputText {...props} type="number" ref={ref} />;
});

export default GeneriInputId;
